import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { translate } from 'react-i18next';
import { Icon } from 'react-icons-kit';
import { sort } from 'react-icons-kit/fa/sort';
import { ic_expand_less } from 'react-icons-kit/md/ic_expand_less';
import { ic_expand_more } from 'react-icons-kit/md/ic_expand_more';

import Info from 'components/Info/Info';
import Button from 'components/Button/Button';
import Warning from 'components/Warning/Warning';
import CheckBox from 'components/CheckBox/CheckBox';
import Download from 'components/Download/Download';
import TableRow from 'components/TableRow/TableRow';
import CustomModal from 'components/CustomModal/CustomModal';
import CompareSelector from 'components/CompareSelector/CompareSelector';
import Utils from 'utils/Utils';
import {
  removeCustomWMSLayer, removeAllCustomWMSLayer, isCustomWMSLayerActive,
	initCompareMap, setCustomWMSLayerOpacity, addCustomWMSLayer, initSwipeCompareMap,
	centerOnFotogram, getCenterOfGeometry, getExtentByCoordinates, initSpyCompareMap,
} from 'utils/Visor';

import './List.css';

import RequestService from 'services/RequestService';

declare var ol;
declare var CONFIGURATIONS;

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fotograms: [],
      selected: [],
      selectedFullFeatures: [],
      asc: true,
      open: false,
      modalOption: undefined,
      selectedInfo: {},
      formats: [],
      collapsed: [],
      downloadData: [],
    };
  }

  componentWillMount() {
    this.loadFotograms(this.props.selectedFeatures, this.state.asc);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({ fotograms: nextProps.selectedFeatures, selectedFullFeatures: nextProps.selectedFullFeatures }, () => {
        this.loadFotograms(nextProps.selectedFeatures, this.state.asc);
      });
    }
  }

  loadFotograms = (fotograms, asc, callback) => {
    let res = fotograms.sort((a, b) => {
      const flight1 = this.getFlightOfFotogram(a);
      const flight2 = this.getFlightOfFotogram(b);
      const aux1 = flight1.title + ' ' + a.substring(a.lastIndexOf('\\') + 1, a.lastIndexOf('.'));
      const aux2 = flight2.title + ' ' + b.substring(b.lastIndexOf('\\') + 1, b.lastIndexOf('.'));
      return Utils.compareStrings(aux1, aux2);
    });

    if (asc === false) {
      res = res.reverse();
    }

    const newSelected = this.state.selected.filter((item) => {
      return res.indexOf(item) > -1;
    });

    this.setState({ fotograms: res, asc: asc, selected: newSelected }, () => {
      if (callback) {
        callback();
      }
    });
  }

  select = (id) => {
    let newSelected = [];
    if (this.state.selected.indexOf(id) > -1) {
      newSelected = this.state.selected.filter(item => item !== id);
    } else {
      newSelected = this.state.selected;
      newSelected.push(id);
    }

    this.setState({ selected: newSelected });
  }

  selectAll = () => {
    if (this.state.selected.length === this.state.fotograms.length) {
      this.setState({ selected: [] });
    } else {
      this.setState({ selected: this.state.fotograms });
    }
  }

  changeOpacity = (id, newOpacity) => {
    const fotograms = [].concat(this.state.fotograms);
		const ff = this.state.selectedFullFeatures.filter(item => item.properties[CONFIGURATIONS.fotogram_attr] === id)[0];
    if (ff !== undefined) {
      if (isCustomWMSLayerActive(ff.properties.layer_id)) {
        setCustomWMSLayerOpacity(ff.properties.layer_id, newOpacity);
      }
    }

    this.loadFotograms(fotograms, this.state.asc);
  }

  allFotogramsOpenedSameLayer = (fotogram) => {
    const selectedFullFeatures = this.state.selectedFullFeatures;
    let res = false;
    const fullFotogram = selectedFullFeatures.filter((item) => {
      return item.properties[CONFIGURATIONS.fotogram_attr] === fotogram;
    })[0];

    let opened = selectedFullFeatures.filter((item) => {
      return isCustomWMSLayerActive(item.properties.layer_id);
    });

    if (opened.length > 0) {
      let layer = '';
      this.props.allFlights.forEach((flight) => {
        if (opened[0].properties.fly_id.indexOf(flight.fly_id) > -1) {
          layer = flight.fly_id;
        }
      });

      if (layer !== '') {
        let sameLayer = opened.filter((o) => {
          return o.properties.fly_id.indexOf(layer) > -1 && fullFotogram.properties.fly_id.indexOf(layer) > -1;
        });

        res = res || (opened.length === sameLayer.length);
      }
    } else {
      res = res || true;
    }

    return res;
  }

  changeOpened = (id) => {
    const _this = this;
    const fotograms = [].concat(this.state.fotograms);
    _this.setState({ open: true, modalOption: 'wait' }, () => {
      const fotogram = this.state.fotograms.indexOf(id) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(id)] : undefined;
      if (fotogram !== undefined) {
				const ff = this.state.selectedFullFeatures.filter(item => item.properties[CONFIGURATIONS.fotogram_attr] === fotogram)[0];
        if (isCustomWMSLayerActive(ff.properties.layer_id)) {
          removeCustomWMSLayer(ff.properties.layer_id);
        } else {
          _this.props.block();
          if (!_this.allFotogramsOpenedSameLayer(fotogram)) {
            removeAllCustomWMSLayer();
          }

          const flight = _this.getFlightOfFotogram(fotogram);
					const centersFile = flight.resources.filter((r) => r.mimetype === 'application/geo+json' && r.name.indexOf('Centroide Fotogramas') > -1)[0].url;
					Utils.getFile(centersFile).then((geojson) => {
						let fullFotogram = undefined;
            let coord = [];
            for (let feature of geojson.features) {
              if (feature.properties[CONFIGURATIONS.fotogram_attr] === fotogram) {
								fullFotogram = feature;
                coord = feature.geometry.coordinates;
                break;
              }
            }

            _this.props.selectTempFlight(flight);
            const serviceUrl = fullFotogram.properties.url_wms;
            addCustomWMSLayer(serviceUrl, fullFotogram.properties.layer_id, _this.props.unblock);
            centerOnFotogram(fotogram, coord);
          });
        }

        _this.setState({ open: false, modalOption: undefined }, () => {
          _this.loadFotograms(fotograms, _this.state.asc);
        });
      }
    });
  }

  sort = () => {
    const newSort = !this.state.asc;
    this.loadFotograms(this.state.fotograms, newSort);
  }

  deleteFotogram = (id) => {
    const _this = this;
    let fotogram = this.state.fotograms.indexOf(id) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(id)] : undefined;
    if (fotogram !== undefined) {
      let newFotograms = this.state.fotograms.filter(item => item !== id);
			const fullFeature = this.state.selectedFullFeatures.filter(item => item.properties[CONFIGURATIONS.fotogram_attr] === id)[0];
      let newFullFeatures = this.state.selectedFullFeatures.filter(item => item.properties[CONFIGURATIONS.fotogram_attr] !== id);
      if (isCustomWMSLayerActive(fullFeature.properties.layer_id)) {
        removeCustomWMSLayer(fullFeature.properties.layer_id);
      }

      this.setState({ selected: [] }, () => {
        _this.loadFotograms(newFotograms, this.state.asc, () => {
          _this.props.selectFeatures(newFotograms, newFullFeatures);
        });
      });
    }
  }

  deleteAll = () => {
    const _this = this;
    if (this.state.selected.length > 0) {
      let ids = [];
      let newFotograms = this.state.fotograms.filter((item) => {
        if (this.state.selected.indexOf(item) > -1) {
          ids.push(item);
        }

        return this.state.selected.indexOf(item) < 0;
      });

      let newFullFeatures = this.state.selectedFullFeatures.filter((item) => {
        return this.state.selected.indexOf(item.properties[CONFIGURATIONS.fotogram_attr]) < 0;
      });

      newFotograms = Utils.sortArrayByProperty(newFotograms, 'name', this.state.asc);
      ids.forEach((fId) => {
        const fotogram = this.state.fotograms.indexOf(fId) > -1 ? this.state.fotograms[this.state.fotograms.indexOf(fId)] : undefined;
        if (fotogram !== undefined) {
					const fullFeature = this.state.selectedFullFeatures.filter(item => item.properties[CONFIGURATIONS.fotogram_attr] === fotogram)[0];
          if (isCustomWMSLayerActive(fullFeature.properties.layer_id)) {
            removeCustomWMSLayer(fullFeature.properties.layer_id);
          }
        }
      });

      this.setState({ selected: [], collapsed: [] }, () => {
        _this.loadFotograms(newFotograms, this.state.asc, () => {
          _this.props.selectFeatures(newFotograms, newFullFeatures);
        });
      });
    } else {
      removeAllCustomWMSLayer();
      this.setState({ fotograms: [], selected: [], collapsed: [] }, () => {
        _this.props.selectTempFlight(undefined);
        _this.props.selectFeatures([], []);
      });
    }
  }

  onCloseModal = () => {
    this.setState({ open: false, modalOption: undefined, selectedInfo: {}, downloadData: [] });
  };

  getFlightOfFotogram = (fotogram) => {
    let flightRes = {};
    const fullFeature = this.state.selectedFullFeatures.filter((item) => {
      return item.properties[CONFIGURATIONS.fotogram_attr] === fotogram;
    });

    if (fullFeature.length > 0) {
      const flight = this.props.allFlights.filter((item) => {
        return Utils.stringContainsString(item.fly_id, fullFeature[0].properties.fly_id);
      });

      if (flight.length > 0) {
        flightRes = flight[0];
      }
    }

    return flightRes;
  }

  downloadList = () => {
		this.props.block();
		const requests = [];
		const selectedData = [];
		this.state.selected.forEach((fotogram) => {
			requests.push(RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/package_search?fq=fotograma*&q=*/${fotogram}.*&rows=1`));
		});

		Promise.all(requests).then((responses) => {
			responses.forEach((response, index) => {
				let results = response.result.results;
				if (results.length > 1) {
					results = results.filter((item) => {
						let add = false;
						item.resources.forEach((r) => {
							add = add || r.resource_type === 'ECW' || r.resource_type === 'PNG';
						});

						return add;
					});
				}

				selectedData.push(results[0]);
			});

			this.props.unblock();
			this.setState({ open: true, modalOption: 'download', downloadData: selectedData });
		}).catch((err) => {
			this.props.unblock();
			this.setState({ open: true, modalOption: 'error-downloading' });
		});
  }

  showInfoFotogram = (id) => {
    const _this = this;
    this.props.block();
    RequestService.getRequest(`${CONFIGURATIONS.ckan_url}/package_search?fq=fotograma*&q=*/${id}.*`).then((response) => {
      const results = response.result.results;
      _this.props.unblock();
      if (results.length > 0) {
        _this.setState({ open: true, modalOption: 'info', selectedInfo: results[0] });
      }
    }).catch((err) => {
      _this.props.unblock();
      _this.setState({ open: true, modalOption: 'error-info' });
    });
  }

  collapse = (flightId) => {
    let newCollapsed = [];
    if (this.state.collapsed.indexOf(flightId) > -1) {
      newCollapsed = this.state.collapsed.filter((id) => id !== flightId);
    } else {
      newCollapsed.push(flightId);
      newCollapsed = newCollapsed.concat(this.state.collapsed);
    }

    this.setState({ collapsed: newCollapsed });
  }

  openCompareSelector = () => {
      this.setState({ open: true, modalOption: 'compare-selector' });
  }

  compareSelected = () => {
    const { t } = this.props;
    let features = this.state.selectedFullFeatures.filter((item) => {
      return this.state.selected.indexOf(item.properties[CONFIGURATIONS.fotogram_attr]) > -1;
    });

    const f1 = document.querySelector('#selectFotogram1').value;
    const f2 = document.querySelector('#selectFotogram2').value;
    if (features.length === 2) {
      const newFeatures = [];
      newFeatures[0] = features.filter((f) => f.properties.frame_id === f1)[0];
      newFeatures[1] = features.filter((f) => f.properties.frame_id === f2)[0];
      features = newFeatures;
    } else if (features.length === 3) {
      const f3 = document.querySelector('#selectFotogram3').value;
      const newFeatures = [];
      newFeatures[0] = features.filter((f) => f.properties.frame_id === f1)[0];
      newFeatures[1] = features.filter((f) => f.properties.frame_id === f2)[0];
      newFeatures[2] = features.filter((f) => f.properties.frame_id === f3)[0];
      features = newFeatures;
    } else if (features.length === 4) {
      const f3 = document.querySelector('#selectFotogram3').value;
      const f4 = document.querySelector('#selectFotogram4').value;
      const newFeatures = [];
      newFeatures[0] = features.filter((f) => f.properties.frame_id === f1)[0];
      newFeatures[1] = features.filter((f) => f.properties.frame_id === f3)[0];
      newFeatures[2] = features.filter((f) => f.properties.frame_id === f2)[0];
      newFeatures[3] = features.filter((f) => f.properties.frame_id === f4)[0];
      features = newFeatures;
    }

    this.setState({ open: true, modalOption: 'compare' }, () => {
      document.querySelector('.modalOverlay').style.padding = '0px';
      document.querySelector('.modalOverlay > div').style.minWidth = '100vw';
      document.querySelector('.modalOverlay > div').style.minHeight = '100vh';
      const maps = [];
      const width = features.length === 2 ? 'calc(50% - 4px)' : features.length === 4 ? 'calc(100% - 4px)' : 'calc(33.33% - 4px)';
      const height = features.length > 3 ? 'calc(50vh - 30px - 1.2rem)' : features.length === 3 ? 'calc(100vh - 60px - 2.4rem)' : 'calc(100vh - 51px - 2.4rem)';
      features.forEach((f, i) => {
        const flight = this.getFlightOfFotogram(f.properties[CONFIGURATIONS.fotogram_attr]);
        maps.push(
          <div className='compare-map' key={'map' + i} id={'map' + i} style={{ width, height }}>
            <div className='compare-title'><b>{t('list.flight') + ': '}</b><p>&nbsp;&nbsp;{flight.title.replaceAll('.', '').replaceAll('Fotografías aéreas', 'F. a.')}</p>&nbsp;&nbsp;|&nbsp;&nbsp;<b>{t('list.fotogram') + ': '}</b>&nbsp;&nbsp;{f.properties[CONFIGURATIONS.fotogram_attr]}</div>
          </div>
        );
      });

      let content = <React.Fragment>{maps}</React.Fragment>;
      if (maps.length > 3) {
        content = <React.Fragment>
          <div style={{ width: '50%' }}>{maps.slice(0, 2)}</div>
          <div style={{ width: '50%' }}>{maps.slice(2, 4)}</div>
        </React.Fragment>;
      }

      ReactDOM.render(content, document.getElementById('compareContainer'));
      setTimeout(() => {
        const flight = this.getFlightOfFotogram(features[0].properties[CONFIGURATIONS.fotogram_attr]);
				const marksFile = flight.resources.filter((r) => r.mimetype === 'application/geo+json' && r.name.indexOf('Huella Fotogramas') > -1)[0].url;
        Utils.getFile(marksFile).then((geojson) => {
          let extent = [];
          for (let f of geojson.features) {
            if (f.properties[CONFIGURATIONS.fotogram_attr] === features[0].properties[CONFIGURATIONS.fotogram_attr]) {
              extent = getExtentByCoordinates(f.geometry);
              break;
            }
          }

          const maps = [];
          features.forEach((f, i) => {
            const url = f.properties.url_wms;
            let coords = f.geometry !== undefined ? ol.proj.fromLonLat(f.geometry.coordinates, 'EPSG:25830') : f.properties.geometry.flatCoordinates;
            if (f.geometry !== undefined && Utils.stringContainsString(f.geometry.type, 'polygon')) {
              coords = getCenterOfGeometry(f.geometry);
            }

            const m = initCompareMap('map' + i, url, f.properties.layer_id, coords, extent);
            maps.push(m);
          });

          maps.forEach((m) => {
            const associated = maps.filter((fm) => {
              return fm.getTarget() !== m.getTarget();
            });

            m.addInteraction(new ol.interaction.Synchronize({ maps: associated }));
          });
        });
      }, 1000);
    });
  }

  compareSwipe = () => {
    const { t } = this.props;
    let features = this.state.selectedFullFeatures.filter((item) => {
      return this.state.selected.indexOf(item.properties[CONFIGURATIONS.fotogram_attr]) > -1;
    });

    this.setState({ open: true, modalOption: 'compare' }, () => {
      document.querySelector('.modalOverlay').style.padding = '0px';
      document.querySelector('.modalOverlay > div').style.minWidth = '100vw';
      document.querySelector('.modalOverlay > div').style.minHeight = '100vh';
      const flight1 = this.getFlightOfFotogram(features[0].properties[CONFIGURATIONS.fotogram_attr]);
      const flight2 = this.getFlightOfFotogram(features[1].properties[CONFIGURATIONS.fotogram_attr]);
      const width = 'calc(100% - 4px)';
      const height = 'calc(100vh - 51px - 2.4rem)';
      const content = <React.Fragment>
        <div className='compare-swipe-map' id={'compareSwipeMap'} style={{ width, height }}>
          <div className='compare-title'>
            <b>{t('list.flight') + ': '}</b><p>&nbsp;&nbsp;{flight1.title.replaceAll('.', '').replaceAll('Fotografías aéreas', 'F. a.')}</p>&nbsp;&nbsp;|&nbsp;&nbsp;
            <b>{t('list.fotogram') + ': '}</b>&nbsp;&nbsp;{features[0].properties[CONFIGURATIONS.fotogram_attr]}
          </div>
          <div className='compare-title'>
            <b>{t('list.flight') + ': '}</b><p>&nbsp;&nbsp;{flight2.title.replaceAll('.', '').replaceAll('Fotografías aéreas', 'F. a.')}</p>&nbsp;&nbsp;|&nbsp;&nbsp;
            <b>{t('list.fotogram') + ': '}</b>&nbsp;&nbsp;{features[1].properties[CONFIGURATIONS.fotogram_attr]}
          </div>
        </div>
      </React.Fragment>;

      ReactDOM.render(content, document.getElementById('compareContainer'));
      setTimeout(() => {
        initSwipeCompareMap('compareSwipeMap', features[0].properties.url_wms, features[1].properties.url_wms, features[0].properties.layer_id, features[1].properties.layer_id, features[0].properties.geometry.getCoordinates());
      }, 500);
    });
  }

  compareSpy = () => {
    const { t } = this.props;
    let features = this.state.selectedFullFeatures.filter((item) => {
      return this.state.selected.indexOf(item.properties[CONFIGURATIONS.fotogram_attr]) > -1;
    });

    this.setState({ open: true, modalOption: 'compare' }, () => {
      document.querySelector('.modalOverlay').style.padding = '0px';
      document.querySelector('.modalOverlay > div').style.minWidth = '100vw';
      document.querySelector('.modalOverlay > div').style.minHeight = '100vh';
      const flight1 = this.getFlightOfFotogram(features[0].properties[CONFIGURATIONS.fotogram_attr]);
      const flight2 = this.getFlightOfFotogram(features[1].properties[CONFIGURATIONS.fotogram_attr]);
      const width = 'calc(100% - 4px)';
      const height = 'calc(100vh - 51px - 2.4rem)';
      const content = <React.Fragment>
        <div className='compare-spy-map' id={'compareSpyMap'} style={{ width, height }}>
          <div className='compare-title'>
            <b>{t('list.flight') + ': '}</b><p>&nbsp;&nbsp;{flight1.title.replaceAll('.', '').replaceAll('Fotografías aéreas', 'F. a.')}</p>&nbsp;&nbsp;|&nbsp;&nbsp;
            <b>{t('list.fotogram') + ': '}</b>&nbsp;&nbsp;{features[0].properties[CONFIGURATIONS.fotogram_attr]}
          </div>
          <div className='compare-title'>
            <b>{t('list.flight') + ': '}</b><p>&nbsp;&nbsp;{flight2.title.replaceAll('.', '').replaceAll('Fotografías aéreas', 'F. a.')}</p>&nbsp;&nbsp;|&nbsp;&nbsp;
            <b>{t('list.fotogram') + ': '}</b>&nbsp;&nbsp;{features[1].properties[CONFIGURATIONS.fotogram_attr]}
          </div>
        </div>
      </React.Fragment>;

      ReactDOM.render(content, document.getElementById('compareContainer'));
      setTimeout(() => {
        initSpyCompareMap('compareSpyMap', features[0].properties.url_wms, features[1].properties.url_wms, features[0].properties.layer_id, features[1].properties.layer_id, features[0].properties.geometry.getCoordinates());
      }, 500);
    });
  }

  render() {
    const { t } = this.props;
    const { open, modalOption, downloadData, selectedFullFeatures } = this.state;
    let fotograms = [];
    if (this.state.fotograms.length > 0) {
      let firstFlight = {};
      for (let i = 0; i < this.state.fotograms.length; i++) {
        const f = this.state.fotograms[i];
        const fotogramFlight = this.getFlightOfFotogram(f);
        const fullFotogram = selectedFullFeatures.filter(item => item.properties[CONFIGURATIONS.fotogram_attr] === f)[0];
        if (firstFlight.fly_id !== fotogramFlight.fly_id) {
          fotograms.push(
            <tr className='tableRow' key={'flight' + fotogramFlight.title}>
              <td colSpan={4} className='flightTableRow clickable' onClick={this.collapse.bind(null, fotogramFlight.fly_id)}>
                {fotogramFlight.innerShortTitle.replaceAll('.', '')}
                {this.state.collapsed.indexOf(fotogramFlight.fly_id) === -1 ?
                  <span className='collapse-icon'><Icon size={'1.5rem'} icon={ic_expand_less} /></span>
                  : <span className='collapse-icon'><Icon size={'1.5rem'} icon={ic_expand_more} /></span>}
              </td>
            </tr>
          );
        }

        if (this.state.collapsed.indexOf(fotogramFlight.fly_id) === -1) {
          fotograms.push(<TableRow key={'f' + i} data={f} fullData={fullFotogram} select={this.select.bind(null, f)}
            flight={fotogramFlight} isSelected={this.state.selected.indexOf(f) > -1}
            openHideFotogram={this.changeOpened.bind(null, f)} changeOpacity={this.changeOpacity.bind(null, f)}
            deleteFotogram={this.deleteFotogram.bind(null, f)} showInfoPopup={this.showInfoFotogram.bind(null, f)} />);
        }

        firstFlight = fotogramFlight;
      }
    }

    return (
      <Fragment>
        <div className='listContainer'>
          <div className='listTitleContainer row'><span>{t('list.my_list') + ' '} ({this.state.fotograms.length})</span></div>
          {this.state.fotograms.length > 0 ?
            <Fragment>
              <div className='table row'>
                <div style={{ overflowY: 'auto', overflowX: 'hidden', maxHeight: 'calc(100vh - 640px)', width: '430px', minHeight: '200px' }}>
                  <table style={{ borderCollapse: 'collapse', width: '420px' }}>
                    <thead>
                      <tr className='tableRowHeader'>
                        <th className='tableCell'><CheckBox onClick={this.selectAll} isSelected={this.state.selected.length === this.state.fotograms.length} all={true} /></th>
                        <th className='tableCell'>{t('list.fotograms')}
                          <span className='sortButton' onClick={this.sort}>
                            <Icon size={'12px'} icon={sort} />
                          </span>
                        </th>
                        <th className='tableCell'>{t('list.opacity')}</th>
                        <th className='tableCell'>{t('list.actions')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {fotograms}
                    </tbody>
                  </table>
                </div>
              </div>
              {this.state.selected.length > 0 ?
                <div className='row'>
                  <p style={{ width: '100%', marginTop: '0rem', marginBottom: '2rem', fontSize: '12px' }}>{t('list.selected') + ': '}<b>{this.state.selected.length}</b></p>
                </div>
                : null}
              <div className='listButtonsContainer row'>
                <Button text={t('list.remove')} active={this.state.selected.length > 0} onClick={this.deleteAll} />
                <Button text={t('list.download')} active={this.state.selected.length > 0} onClick={this.downloadList} />
                <Button text={t('list.compare')} active={this.state.selected.length > 1 && this.state.selected.length < 5}
                  active2={this.state.selected.length === 2} active3={this.state.selected.length === 2}
                  text1={'Mapas separados'} text2={'Mapa en modo continuo'} text3={'Mapa en modo espía'}
                  onClick={this.openCompareSelector} onClick2={this.compareSwipe} onClick3={this.compareSpy} />
              </div>
            </Fragment>
            : null}
        </div>
        {modalOption === 'info' ?
            <CustomModal open={open} onClose={this.onCloseModal} title={t('list.info')}>
              <Info variant='fotogram' data={this.state.selectedInfo} />
            </CustomModal>
        : modalOption === 'download' ?
          <CustomModal open={open} onClose={this.onCloseModal} title={t('list.download_fotograms')}>
            <Download data={downloadData} />
          </CustomModal>
        : modalOption === 'compare-selector' ?
          <CustomModal open={open} onClose={this.onCloseModal} title={'Configurar comparación'}>
            <div id='compareSelectorContainer' className='compare-selector-container'>
              <CompareSelector selected={this.state.selected} fullFotograms={selectedFullFeatures}
                getFlightOfFotogram={this.getFlightOfFotogram} openComparator={this.compareSelected} />
            </div>
          </CustomModal>
        : modalOption === 'compare' ?
          <CustomModal open={open} onClose={this.onCloseModal} title={t('list.compare_fotograms')}>
            <div id='compareContainer' className='compare-container'>
            </div>
          </CustomModal>
        : <CustomModal open={open} onClose={this.onCloseModal}>
            <Warning>
              { modalOption === 'wait' ?
                <p style={{ width: '160px', textAlign: 'center' }}>{t('list.please_wait')}</p>
              : modalOption === 'error-area-selected' ?
                <p style={{ width: '160px', textAlign: 'center' }}>{t('list.not_area')}</p>
              : modalOption === 'error-downloading' ?
                <p style={{ width: '160px', textAlign: 'center' }}>{t('list.download_error')}</p>
              : modalOption === 'error-info' ?
                <p style={{ width: '160px', textAlign: 'center' }}>{t('list.info_error')}</p>
              : null}
            </Warning>
          </CustomModal>}
      </Fragment>
    );
  }
}

export default translate()(List);
